export default "__VITE_ASSET__4f469573__"